module.exports = __webpack_public_path__ + "img/rechtseinfuegen.7a2a022.svg";